import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "EnterpriseGroupListPage" */
	'pages/EnterpriseGroup/EnterpriseGroupListPage'));

export default [{ component, exact: true, path: '/enterprise_groups' }];